<template>
  <div class="logotype">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -20 4140 740" fill="none">
      <!-- Знак: потоки (мульти-аккаунты) сливаются в стрелку трафика, без плашки -->
      <defs>
        <linearGradient id="tf-logo-grad" x1="0" y1="0" x2="620" y2="700" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="#6d28d9"/>
          <stop offset="1" stop-color="#9333ea"/>
        </linearGradient>
      </defs>
      <g transform="translate(-130 -88) scale(1.25)">
        <path d="M140 200 C300 200 330 336 440 346" stroke="url(#tf-logo-grad)" stroke-width="72" stroke-linecap="round" opacity=".45"/>
        <path d="M140 350 L440 350" stroke="url(#tf-logo-grad)" stroke-width="72" stroke-linecap="round" opacity=".7"/>
        <path d="M140 500 C300 500 330 364 440 354" stroke="url(#tf-logo-grad)" stroke-width="72" stroke-linecap="round"/>
        <path d="M455 245 L600 350 L455 455 Z" fill="url(#tf-logo-grad)"/>
      </g>
      <!-- TRAFFERS — MURS Gothic Wide Black, кривыми (не зависит от загрузки шрифта) -->
      <g transform="translate(770 165) scale(0.53)">
        <path style="fill:rgb(var(--black))" d="M243 700H524V183H746V0H20V183H243Z M826 700H1098V445H1211L1314 700H1622L1469 393C1533 365 1597 311 1597 213C1597 95 1506 0 1323 0H826ZM1238 291H1099V157H1238C1288 157 1313 182 1313 222C1313 263 1288 291 1238 291Z M1633 700H1876L1912 580H2134L2170 700H2465L2225 0H1874ZM1958 429 2023 201 2088 429Z M2513 700H2788V436H3082V264H2788V174H3155V0H2513Z M3245 700H3520V436H3814V264H3520V174H3887V0H3245Z M3977 700H4641V528H4252V419H4566V257H4252V172H4641V0H3977Z M4731 700H5003V445H5116L5219 700H5527L5374 393C5438 365 5502 311 5502 213C5502 95 5411 0 5228 0H4731ZM5143 291H5004V157H5143C5193 157 5218 182 5218 222C5218 263 5193 291 5143 291Z M5944 713C6223 713 6325 613 6325 467C6325 330 6237 262 6064 234L5919 210C5871 202 5857 187 5857 163C5857 135 5877 115 5948 115C6020 115 6040 136 6048 170L6280 152C6269 66 6179 -13 5951 -13C5679 -13 5576 90 5576 221C5576 348 5659 423 5828 446L5984 468C6027 475 6043 491 6043 517C6043 548 6022 570 5957 570C5885 570 5846 540 5828 499L5558 568C5588 636 5685 713 5944 713Z"/>
      </g>
    </svg>
  </div>
</template>

<style>
.logotype {
  svg {
    height: 1.8125rem;
    width: auto;
    top: -1px;
    position: relative;
  }
}
</style>
